import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appCsHeader]'
})
export class CsHeaderDirective {

    constructor(public viewContainerRef: ViewContainerRef) { }

}
